module.exports = __webpack_public_path__ + "static/img/weilingqu-2.bd14b8fa.png";